import type {
  AuthResponse,
  LoginInput,
  LoginResponse,
  PublicCaptchaConfigDTO,
  UserDTO,
} from '@bruno/shared';
import { isTwoFactorChallenge } from '@bruno/shared';
import { api, setAccessToken } from './client';

export async function login(input: LoginInput): Promise<LoginResponse> {
  const res = await api<LoginResponse>('/v1/auth/login', { method: 'POST', body: input });
  if (!isTwoFactorChallenge(res)) {
    setAccessToken(res.accessToken);
  }
  return res;
}

export async function logout(): Promise<void> {
  await api<void>('/v1/auth/logout', { method: 'POST', retryOn401: false });
  setAccessToken(null);
}

export async function getMe(): Promise<{ user: UserDTO }> {
  return api<{ user: UserDTO }>('/v1/auth/me');
}

export async function tryRestoreSession(): Promise<UserDTO | null> {
  try {
    const res = await api<AuthResponse>('/v1/auth/refresh', { method: 'POST', retryOn401: false });
    setAccessToken(res.accessToken);
    return res.user;
  } catch {
    return null;
  }
}

export async function getCaptchaConfig(): Promise<PublicCaptchaConfigDTO> {
  return api<PublicCaptchaConfigDTO>('/v1/auth/captcha-config', { retryOn401: false });
}
